<!-- //
Nav导航头的客服
@auth xuyd
@date 2024-05-01
//-->
<template>
  <div class="nav-menu" @click="goto">
    <el-tooltip content="点击查看帮助">
      <svg-icon icon="icon-kefu" class="nav-icon"/>
    </el-tooltip>
  </div>
</template>

<script>
  export default {
    name: 'Kefu',
    data() {
      return {
        url: ''
      }
    },
    methods: {
      goto() {
        window.open('http://eqops.tc.com/confluence/pages/viewpage.action?pageId=65422817', '_blank');
        // this.$modal.alert('暂无客服')
      }
    }
  }
</script>

<style scoped lang="less">
  .nav-menu {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    i {
      font-size: 20px;
      font-weight: 600
    }
    .nav-icon{
      width: 25px;
      height: 25px;
      overflow: hidden;
    }
  }
</style>
